import React from 'react';

const Icon = ({ size = '48', fill = 'black', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 48 48" fill="none" {...other}>
            <path
                d="M23.352 2.08a1.127 1.127 0 0 1 1.296 0L24 3l.648-.92.001.002c.001 0 .003 0 .004.002l.011.007.04.028c.032.024.08.06.142.104.123.09.302.224.527.397.451.346 1.091.856 1.857 1.51a53.643 53.643 0 0 1 5.62 5.564c4.063 4.685 8.275 11.35 8.275 18.93 0 9.155-7.71 16.5-17.125 16.5S6.875 37.78 6.875 28.625c0-7.58 4.212-14.245 8.275-18.93a53.643 53.643 0 0 1 5.62-5.564 47.058 47.058 0 0 1 1.857-1.51c.225-.173.404-.306.527-.397l.143-.104.039-.028.01-.007.005-.002V2.08c.003.003.031.042.381.539l-.38-.54Zm.646 2.324c-.424.326-1.034.81-1.768 1.437a51.38 51.38 0 0 0-5.38 5.327c-3.937 4.54-7.725 10.687-7.725 17.457 0 7.828 6.617 14.25 14.875 14.25s14.875-6.422 14.875-14.25c0-6.77-3.788-12.918-7.725-17.457a51.38 51.38 0 0 0-5.38-5.327 44.761 44.761 0 0 0-1.768-1.437L24 4.402l-.002.002Z"
                fill={fill}
            />

            <path d="M22.333 36.5v-8.25H19l6.667-13.75v9.167H29L22.333 36.5Z" fill={fill} />
        </svg>
    );
};
export default React.memo(Icon);
